import { FC } from "react";
import { COPAY_TABLE } from "src/constants/todos";
import { headerPorps } from "../types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// const CopayBucketTableHeader: FC<headerPorps> = ({ queryParam, changeIdOrder }) => (
//   <thead className="sticky-top z-1">
//     <tr className="text-center">
//       {COPAY_TABLE.map((tableHeader, index) => (
//         <th key={index}
//           onClick={tableHeader.value !== '' ? () => changeIdOrder(tableHeader.value) : undefined}
//         >
//           <span role={tableHeader.value === '' ? "textbox" : "button"}
//             className={
//               tableHeader.value === '' ?
//                 'fw-bold fs-6 lh-base' :
//                 'btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold'
//             }
//           >{tableHeader.label}
//             {(queryParam as any).sort_by === tableHeader.value ? (
//               <i className={`bi ${(queryParam as any).direction === 'desc' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'}`}></i>
//             ) : null}
//           </span>
//         </th>
//       ))}
//     </tr>
//   </thead>
// );

// export default CopayBucketTableHeader;
const CopayBucketTableHeader: FC<headerPorps> = ({ queryParam, changeIdOrder }) => (
  <thead className="sticky-top z-1">
    <tr className="text-center">
      {COPAY_TABLE.map((tableHeader, index) => (
        <th
          key={index}
          onClick={tableHeader.value !== '' ? () => changeIdOrder(tableHeader.value) : undefined}
        >
          {tableHeader.label === "High Pt Cost Share" ?

          <span
            role={tableHeader.value === '' ? "textbox" : "button"}
            className={
              tableHeader.value === ''
                ? 'fw-bold fs-6 lh-base'
                : 'btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold text-nowrap'
            }
          >
            {tableHeader.label}

            {/* ✅ Info icon only for High Patient Cost Share */}
            {
            //tableHeader.label === "High Pt Cost Share" 
            (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="high-cost-tooltip">
                    Patient out of pocket cost estimated at $100 or greater
                  </Tooltip>
                }
              >
                <i className="bi bi-info-circle-fill ms-1" role="button" />
              </OverlayTrigger>
            )}

            {(queryParam as any).sort_by === tableHeader.value ? (
              <i
                className={`bi ms-1 ${(queryParam as any).direction === 'desc'
                  ? 'bi-caret-down-fill'
                  : 'bi-caret-up-fill'
                  }`}
              />
            ) : null}
          </span> 
          :
           <span
            role={tableHeader.value === '' ? "textbox" : "button"}
            className={
              tableHeader.value === ''
                ? 'fw-bold fs-6 lh-base'
                : 'btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold'
            }
          >
            {tableHeader.label}</span>}
        </th>
      ))}
    </tr>
  </thead>
);
export default CopayBucketTableHeader;

